<template>

	<section>

		<button class="button is-small" @click="edit(contract)" :disabled="archiveLoading || ! archiveButton">View Details</button>
		
		<b-button :loading="archiveLoading" type="is-small is-warning" style="width:50px;" 

		@click="archive(contract.id)" v-if="archiveButton" :disabled="!canManageContract">
		
			Archive

		</b-button>

		<b-button :loading="restoreLoading" type="is-small is-dark" style="width:50px;" @click="restore(contract.id)" :disabled="!canManageContract" v-else>
		
			Restore

		</b-button>

		<button class="button is-small is-danger" style="width:50px;" @click="onRemove" v-if="isSuperAdmin">Delete</button>

	</section>

</template>

<script>

import { ContractService } from "@/services/contract.service";
import Roles from "@/helpers/roles";

import moment from 'moment';

export default {

	props: ['contract', 'editstatus', 'createstatus', 'editdata', 'canManageContract'],

    data() {

        return {

            archiveLoading: false,

            restoreLoading: false,

            archiveButton: this.contract.archived_at == null ? true : false,

        }

    },

    computed: {
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
        },
    },

    methods: {

		archive(id) {

			this.archiveLoading = true;

    		ContractService.archive(id).then(response => {

				this.archiveLoading = false;

    			this.archiveButton = false;

    			this.$emit('contract-archived', { id: id, archived_at: moment.utc().toISOString() });

			});

		},

		restore(id) {

			this.restoreLoading = true;

    		ContractService.restore(id).then(response => {

				this.restoreLoading = false;

    			this.archiveButton = true;

    			this.$emit('contract-restored', { id: id, archived_at: null });

			});

		},

		deleteData() {

    		ContractService.delete(this.contract.id).then(response => {

    			this.$parent.fetch();

    		});

		},

		edit(value) {

    		this.$emit('update:editstatus', true)
    		
    		this.$emit('update:editdata', value)

		},

		onRemove() {

			this.$buefy.dialog.confirm({
			
				title: "Confirm",
			
				message: "Are you sure you want to <b>delete</b> this contract?",
			
				confirmText: "Delete",
			
				type: "is-danger",
			
				hasIcon: true,
			
				onConfirm: () => {
			
					this.deleteData();
					
				}
			
			});
		
		},

    },

}

</script>



// WEBPACK FOOTER //
// src/components/pages/Contracts/partials/actions.vue